import { ProfileAPI, ProfileParams } from '../apis/Profile';

export const profileQuery = {
  getProfile: () => ({
    key: ['profile'],
    fn: async ({ params }: { params: ProfileParams }) => {
      const newParams: { [key: string]: string | number | string[] } = {};
      if (params.tickets) {
        params.tickets.forEach((ticket, index) => {
          newParams[`tickets[${index}].deviceId`] = ticket.deviceId;
          if (ticket.ticketNumber) {
            newParams[`tickets[${index}].ticketNumber`] = ticket.ticketNumber;
          }
        });
      }

      // Additional parameters
      if (params.barges) {
        params.barges.forEach((barge, index) => {
          newParams[`barges[${index}]`] = barge;
        });
      }

      if (params.from) {
        newParams['from'] = params.from;
      }

      if (params.to) {
        newParams['to'] = params.to;
      }

      if (params.fields) {
        params.fields.forEach((field, index) => {
          newParams[`fields[${index}]`] = field;
        });
      }

      newParams['format'] = params.format || 2;

      return await ProfileAPI.getProfile({ params: newParams });
    },
  }),
};
